import { isApiReaderEnabledForShop } from '../auth/selectors';
import SharedStrategy from './SharedStrategy';
import {
  capturePayment,
  collectPaymentMethod,
  processPayment,
  saleChargeFail,
} from './actions';
import { readyToPay, setExternalPaymentInfo } from '../register/webReader/actions';
import * as paymentActions from '../register/payment/actions';
import { getIsProcessorMode } from '../register/webReader/selector';
import { paymentFailed, webreaderPaymentSuccess } from '../main/payment/actions';
import { getOnTerminalTipConfiguration } from '../register/validated/selectors';

class PaymentStrategy extends SharedStrategy {
  constructor() {
    super('pay');
  }

  discoverFail(error, dispatch) {
    dispatch(saleChargeFail(error, this.getName()));
  }

  readerConnectSuccess(dispatch) {
    super.readerConnectSuccess(dispatch);
    dispatch(readyToPay());
  }

  readerConnectError(error, dispatch) {
    super.readerConnectError(error, dispatch);
    dispatch(saleChargeFail(error, this.getName()));
  }

  readerSelectCancel(dispatch) {
    dispatch(paymentActions.resetPayments(this.getName()));
  }

  resetWebreaderPayment(dispatch) {
    dispatch(paymentActions.readerTransactionFail());
    this.dispose();
  }

  collectPaymentMethod(state, action, dispatch) {
    const isApiReader = isApiReaderEnabledForShop(state);
    let readerConfigOverrides = null;
    if (!isApiReader) {
      readerConfigOverrides = {
        tipping: getOnTerminalTipConfiguration(state),
      };
    }

    collectPaymentMethod(dispatch, state)(
      action.payload,
      this.getName(),
      isApiReaderEnabledForShop(state),
      readerConfigOverrides,
    );
  }

  process(state, action, dispatch) {
    const isApiReader = isApiReaderEnabledForShop(state);
    let readerConfigOverrides = null;
    if (isApiReader) {
      readerConfigOverrides = {
        tipping: getOnTerminalTipConfiguration(state),
      };
    }

    processPayment(dispatch)(
      action.payload,
      this.getName(),
      isApiReaderEnabledForShop(state),
      readerConfigOverrides,
    );
  }

  capture(state, action, dispatch) {
    // capturing is done by native app in webreader processor mode
    if (getIsProcessorMode(state)) {
      dispatch(setExternalPaymentInfo(null));
      return;
    }

    capturePayment(dispatch)(action.payload, this.getName(), isApiReaderEnabledForShop(state));
  }

  readerTransactionSuccess(state, action, dispatch) {
    dispatch(webreaderPaymentSuccess(action.payload));
    dispatch(paymentActions.readerTransactionSuccess(action.payload));
    this.dispose();
  }

  readerTransactionFail(state, action, dispatch) {
    // don't involve register related handlers in case it's a web view processor
    if (!getIsProcessorMode(state)) {
      dispatch(paymentActions.readerTransactionFail(action.payload));
      dispatch(paymentFailed());
    }

    dispatch(setExternalPaymentInfo(null));
    this.dispose();
  }

  handleCancelTransaction(state, action, dispatch) {
    // don't involve register related handlers in case it's a web view processor
    if (!getIsProcessorMode(state)) {
      dispatch(paymentActions.readerTransactionFail());
      dispatch(paymentFailed());
    }

    this.dispose();
  }
}

export default new PaymentStrategy();
